import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpsellAdData } from "gql/graphql";

export type UpsellAdMetadata = {
  offersAdId?: string;
  offersAdLocation?: string;
  offersPlacementName?: string;
  offersOfferName?: string;
};

export type UpsellAdDataState = {
  healthReportUpsell: null | UpsellAdData;
  adMetadata: UpsellAdMetadata | null;
};

const initialState: UpsellAdDataState = {
  healthReportUpsell: null,
  adMetadata: null,
};

const upsellAdDataSlice = createSlice({
  name: "upsellAdData",
  initialState,
  reducers: {
    setUpsellAdData(state, action: PayloadAction<Partial<UpsellAdDataState>>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setUpsellAdMetadata(state, action: PayloadAction<UpsellAdMetadata>) {
      return { ...state, adMetadata: action.payload };
    },
  },
});

export const { setUpsellAdData, setUpsellAdMetadata } =
  upsellAdDataSlice.actions;

export default upsellAdDataSlice;
